import { Layout } from 'antd';
import { Content, Header } from 'antd/es/layout/layout';
import React from 'react';
import { posMenuItems } from './posMeniItems';
import logo from './../assets/gabaritlogo.png';
import Pos from '../Pages/Pos/Pos';
import { NavLink, Route, Routes } from 'react-router-dom';
import LeftToolbar from './Comps/LeftToolbar';

function PosLayout() {
    return (
        <Layout style={{ minHeight: '100vh', background: 'var(--bg-main)' }}>
            <Header
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 100,
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    background: 'var(--bg-header)',
                    borderBottom: '1px solid var(--border)',
                    boxShadow: 'var(--shadow-xs)',
                    padding: '0 24px',
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <img 
                        src={logo} 
                        alt="Logo" 
                        style={{ height: '32px', width: 'auto' }}
                    />
                    <h1 style={{
                        margin: 0,
                        fontSize: '18px',
                        fontWeight: 700,
                        background: 'var(--gradient)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                    }}>
                        G.A.M
                    </h1>
                </div>
                
                <div className={'posmenu'} style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    {posMenuItems.map(item => (
                        <NavLink 
                            key={item.key} 
                            to={item.link} 
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                backgroundColor: 'var(--primary)',
                                padding: '8px 16px',
                                borderRadius: 'var(--radius-md)',
                                color: 'var(--text-inverse)',
                                fontWeight: 500,
                                transition: 'all var(--transition-base)',
                            }}
                        >
                            {item.icon} {item.label}
                        </NavLink>
                    ))}
                </div>
                
                <LeftToolbar />
            </Header>
            
            <Content style={{ padding: '24px' }}>
                <div
                    style={{
                        background: 'var(--bg-card)',
                        borderRadius: 'var(--radius-lg)',
                        boxShadow: 'var(--shadow-sm)',
                        border: '1px solid var(--border)',
                        height: 'calc(100vh - 64px - 48px)',
                        overflow: 'auto',
                    }}
                >
                    <Routes>
                        <Route path="/" element={<Pos />} />
                    </Routes>
                </div>
            </Content>
        </Layout>
    );
}

export default PosLayout;